import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'

// Only for admin users
export const approveProduct = async (productCode: string, tenant: ITenant) =>
  await axiosInstanceMain.post(`/admin/${tenant.path}/productos/${productCode}/aprobar`)
export const deniedProduct = async (productCode: string, tenant: ITenant) =>
  await axiosInstanceMain.post(`/admin/${tenant.path}/productos/${productCode}/rechazar`)

export const getTenant = async (dominio: string) => await axiosInstanceMain.get(`/tenants?dominio=${dominio}`)

export const getTenants = async () => await axiosInstanceMain.get('/admin/tenants')

export const duplicarLocal = async (tenant: ITenant, codlocal: string, newTenant: ITenant) =>
  await axiosInstanceMain.post(`/admin/${tenant.path}/locales/${codlocal}/duplicar?tenant-destino=${newTenant.path}`)
